/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_IntroInputs */

const en_formatter_intro = /** @type {(inputs: Formatter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-indent minified or inconsistently spaced JSON so the structure becomes readable. Pick two spaces, four spaces, or real tab characters, and the whole document is rewritten to match.`)
};

const ko_formatter_intro = /** @type {(inputs: Formatter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축되거나 들여쓰기가 뒤섞인 JSON을 다시 정렬해 구조가 보이게 만듭니다. 2칸, 4칸, 또는 실제 탭 문자를 선택하면 문서 전체가 그 기준으로 다시 작성됩니다.`)
};

const ja_formatter_intro = /** @type {(inputs: Formatter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮された JSON やインデントがばらばらな JSON を整え直し、構造が見えるようにします。2 スペース、4 スペース、または実際のタブ文字を選ぶと、文書全体がその基準で書き直されます。`)
};

/**
* | output |
* | --- |
* | "Re-indent minified or inconsistently spaced JSON so the structure becomes readable. Pick two spaces, four spaces, or real tab characters, and the whole docum..." |
*
* @param {Formatter_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_intro = /** @type {((inputs?: Formatter_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_intro(inputs)
	if (locale === "ko") return ko_formatter_intro(inputs)
	return ja_formatter_intro(inputs)
});